import { render, staticRenderFns } from "./OrganizationEditForm.vue?vue&type=template&id=14f2d052&scoped=true&"
import script from "./OrganizationEditForm.vue?vue&type=script&lang=ts&"
export * from "./OrganizationEditForm.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationEditForm.vue?vue&type=style&index=0&id=14f2d052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f2d052",
  null
  
)

export default component.exports